//
//
//
//
//
//
//
//
import { isFeatureOn } from '~/utils/isomorphicGrowthbook';
export default {
  props: {
    playbackId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    asset: {
      type: Object,
      required: false
    }
  },

  data() {
    return {
      gb_enabled: null
    };
  },

  async fetch() {
    this.gb_enabled = await isFeatureOn('sanity_video');
  },

  computed: {
    aspectRatio() {
      const ratio = this.asset.data.aspect_ratio;
      const splitRatio = ratio.split(':');
      return splitRatio[0] + ' / ' + splitRatio[1];
    }

  }
};